import { highlight } from '../shiki-ng_VAG35.js';

/**
 * Shiki runs here, so that highlighting never blocks the main thread.
 */
self.onmessage = async event => {
  const {
    id
  } = event.data;
  let response;
  try {
    response = {
      id,
      result: await highlight(event.data)
    };
  } catch (e) {
    response = {
      id,
      error: e instanceof Error ? e.message : String(e)
    };
  }
  self.postMessage(response);
};
//# sourceMappingURL=shiki.worker.js.map
